import PageHeaderManager from './PageHeaderManager';

export default PageHeaderManager;
